"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteMonthlyWelfare = deleteMonthlyWelfare;
exports.getFreePackages = getFreePackages;
exports.getMonthlyWelfareDetail = getMonthlyWelfareDetail;
exports.getMonthlyWelfareJoinPage = getMonthlyWelfareJoinPage;
exports.getMonthlyWelfarePage = getMonthlyWelfarePage;
exports.saveMonthlyWelfare = saveMonthlyWelfare;
exports.updateMonthlyWelfareStatus = updateMonthlyWelfareStatus;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
function getMonthlyWelfarePage(params) {
  return (0, _requestAuth.default)({
    url: '/monthlyWelfare/page',
    method: 'get',
    params: params
  });
}
function getMonthlyWelfareDetail(id) {
  return (0, _requestAuth.default)({
    url: '/monthlyWelfare/' + id,
    method: 'get'
  });
}
function saveMonthlyWelfare(data) {
  return (0, _requestAuth.default)({
    url: '/monthlyWelfare/saveOrUpdate',
    method: 'post',
    data: data
  });
}
function updateMonthlyWelfareStatus(data) {
  return (0, _requestAuth.default)({
    url: '/monthlyWelfare/updateStatus',
    method: 'post',
    data: data
  });
}
function deleteMonthlyWelfare(id) {
  return (0, _requestAuth.default)({
    url: '/monthlyWelfare?id=' + id,
    method: 'delete'
  });
}

/** 启用且 price_type=2 的券包 */
function getFreePackages() {
  return (0, _requestAuth.default)({
    url: '/monthlyWelfare/freePackages',
    method: 'get'
  });
}
function getMonthlyWelfareJoinPage(params) {
  return (0, _requestAuth.default)({
    url: '/monthlyWelfare/join/page',
    method: 'get',
    params: params
  });
}